export const rolesDetails = [
	{
		checkbox: true,
		role: "Admin",
		created_date: "12/09/2024",
		status: "Active",
		key: 1
	},
	{
		checkbox: true,
		role: "HR Manager",
		created_date: "24/10/2024",
		status: "Active",
		key: 2
	},
	{
		checkbox: true,
		role: "Recruitment Manager",
		created_date: "18/02/2024",
		status: "Active",
		key: 3
	},
	{
		checkbox: true,
		role: "Payroll Manager",
		created_date: "17/10/2024",
		status: "Active",
		key: 4
	},
	{
		checkbox: true,
		role: "Leave Manager",
		created_date: "20/07/2024",
		status: "Active",
		key: 5
	},
	{
		checkbox: true,
		role: "Performance Manager",
		created_date: "10/04/2024",
		status: "Active",
		key: 6
	},
	{
		checkbox: true,
		role: "Reports Analyst",
		created_date: "29/08/2024",
		status: "Active",
		key: 7
	},
	{
		checkbox: true,
		role: "Employee",
		created_date: "22/02/2024",
		status: "Active",
		key: 8
	},
	{
		checkbox: true,
		role: "Client",
		created_date: "03/11/2024",
		status: "Active",
		key: 9
	},
	{
		checkbox: true,
		role: "Department Head",
		created_date: "17/12/2024",
		status: "Active",
		key: 10
	}
];
